<template>
    <modal
        name="complete-quiz"
        height="auto"
        :adaptive="true"
        :width="446"
    >
        <div class="modal">
            <span class="modal__title" v-html="'Precondition not met'"></span>
            <span>You need to complete the previous quiz in order to continue</span>
            <TotemButton label="Take the quiz" icon="arrow-right" color="primary" iconPosition="right" @click="retakeTest"/>
        </div>
    </modal>
</template>

<script>
    export default {
        name: 'modal-complete-quiz',
        methods: {
            retakeTest () {
                this.$emit('retake-test')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 20px;
        gap: 30px;

        &__title {
            font-family: PPAgrandir-Medium, sans-serif;
            font-size: 2.4rem;
        }
    }
</style>
